<style>
@import '../../custom/css/editar-dica.css';
</style>

<template>
  <div id="editar-produto" class="editar-dica">
    <div class="form-fields position-relative" v-if="this.produto !== null">
      <h1 class="title text-uppercase font-weight-bold">Editar Produto</h1>
      <hr class="linha-amarela" />
      <div class="form-group">
        <label for="titulo">Título</label>
        <input
          type="text"
          class="form-control"
          id="titulo"
          v-model="produto[0].nome"
        />
      </div>
      <div class="form-group">
        <label for="titulo">Descrição</label>
        <textarea
          class="form-control"
          id="descricao"
          v-model="produto[0].descricao"
        ></textarea>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editarProduto()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse produto não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'editar-produto',
  data: () => ({
    dados: {},
  }),
  props: ['id'],
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      produto: (state) => state.produto,
    }),
  },
  created() {
    this.$store.dispatch('showProduto', this.id);
  },
  activated() {
    this.$store.dispatch('showProduto', this.id);
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    editarProduto() {
      this.$store.dispatch('updateProduto', this.produto).then((data) => {
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso(this.getNotification, 'success');
            setTimeout(() => {
              this.$router.push({ name: 'administrador-lista-produtos' });
            }, 1500);
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
        }, 1000);
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-produtos',
      });
    },
  },
};
</script>
